/*
 *
 *  * Copyright(c) 2022 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

export class AdvanceSearchFilters {
  descriptions = [];
  modality = [];
  bodyParts = [];
  specialties = [];
  departmentIds = [];
  examStatusIds = [];
  protocolStatus = [];
  initialInterpreters = [];
  radiologists = [];
  referringPhysician = [];
  designatedAuthor = [];
  instituteList = [];
  currentLocation = [];
  orderingLocation = [];
  reportStatusIds = [];
  equipment = [];
  site = [];
  aiFinding = [];
  priority = [];
  exceptions = [];
}
